import { empty } from 'views/components/php.js';

function get_web_empresa_congifuracion_vacio() {
  return {
    currency: 'MXN',
    currency_symbol: '$',
    timezone: 'America/Mexico_City',
    data: {
      modulosAutorizados: [],
    },
  };
}

function completar_web_empresa_congifuracion(data = {}) {
  if (empty(data)) {
    return get_web_empresa_congifuracion_vacio();
  }

  if (empty(data.currency)) {
    data.currency = 'MXN';
  }
  if (empty(data.currency_symbol)) {
    data.currency_symbol = '$';
  }
  if (empty(data.timezone)) {
    data.timezone = 'America/Mexico_City';
  }
  return data;
}

export {
  get_web_empresa_congifuracion_vacio,
  completar_web_empresa_congifuracion,
};
